module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iIzM3N2UzZiIgZD0iTTAtLjA1aDUxMnY1MTIuMUgweiIvPgogIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDEwMi4zN2g1MTJ2MzA3LjI2SDB6Ii8+CiAgPHBhdGggZmlsbD0iI2I0MGEyZCIgZD0iTTAgMTUzLjU4aDUxMnYyMDQuODRIMHoiLz4KICA8cGF0aCBkPSJNMjU1Ljg5MyAxNjMuMzZsNjAuMiAxODUuMjgtMTU3LjYwNy0xMTQuNTFIMzUzLjNMMTk1LjY5NCAzNDguNjR6IiBmaWxsPSIjZWNjODFkIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/sr.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/sr.svg
// module chunks = 0